module.exports = __webpack_public_path__ + "static/img/bg-5.af4e41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/bnaner/bg-5.png
// module id = CSHP
// module chunks = 0